<template>
  <div>
    <div class="text-14px grid gap-x-2 lg:text-center xl:text-left
                grid-cols-[30fr_24fr_24fr_30fr_20fr_16fr] 
                lg:grid-cols-[175px_24fr_24fr_30fr_24fr_26fr] 
                xl:grid-cols-[49.5fr_30fr_24fr_30fr_24fr_26fr]
                rounded-8px bg-gray-600 mt-2">
      <div class="flex items-center p-2">
        <a class="flex flex-col lg:flex-row items-center relative py-2 text-blue-10 payout-date-link"
           href="#" @click.prevent="navigateToPayoutItems">
           <span>
             {{ payout.payout_date_range.first_date }}
           </span>
          <span class='hidden px-1 lg:inline-block'>-</span>
          <template v-if="payout.payment_state === 'Unpaid'">
            {{ $t('profiles.payout_lists.present') }}
          </template>
          <template v-else>
            <span>
             {{ payout.payout_date_range.last_date }}
           </span>
          </template>
        </a>
      </div>
      <div class='flex items-center lg:justify-center xl:justify-start py-2'>
        {{ formatCurrency(payout.total_revenues) }}
      </div>
      <div class='flex items-center lg:justify-center xl:justify-start py-2'>
        {{ formatCurrency(payout.total_commission_price) }}
      </div>
      <div class='flex items-center lg:justify-center xl:justify-start py-2'>
        {{ formatCurrency(payout.total_pv_commission_price) }}
      </div>
      <div class='flex items-center lg:justify-center xl:justify-start py-2'>
        {{ formatCurrency(payout.total_price) }}
      </div>
      <div class='flex items-center lg:justify-center xl:justify-start py-2'>
        <span class="rounded-3xl px-2 py-0.5 text-12px border"
              :style="getPaymentStateStyle(payout.payment_state)">
          {{ payout.payment_state }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'PayoutItem',
  
  props: {
    payout: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  
  setup(props) {
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    const navigateToPayoutItems = async () => {
      const { first_date, last_date } = props.payout.payout_date_range;
      const dateStart = formatDate(first_date);
      const dateEnd = formatDate(last_date);

      try {
        sessionStorage.setItem('orderPayoutListDates', JSON.stringify({ start: dateStart, end: dateEnd }));
        window.location.href = '/profile/payout_items';
      } catch (error) {
        console.error('Error storing dates:', error);
      }
    };

    return {
      navigateToPayoutItems,
    };
  },


  methods: {
    formatCurrency(amount) {
      return new Intl.NumberFormat('zh-TW', {
        style: 'currency',
        currency: 'TWD',
        minimumFractionDigits: 0
      }).format(amount);
    },
    
    getPaymentStateStyle(state) {
      return {
        color: `var(--color-payout-state-${state.toLowerCase()})`,
        background: `color-mix(in srgb, var(--color-payout-state-${state.toLowerCase()}), transparent 80%)`,
        borderColor: `var(--color-payout-state-${state.toLowerCase()})`
      };
    }
  }
});
</script>